<template>
  <div>
    <!-- <pdf-button :additional-query-string-params="queryParams" />
     -->
    <excel-button title="Merit Incentive" />
    <h1>Merit Incentive Fund</h1>
    <h2><lea-display :lea="selectedLea" /></h2>

    <!-- We include the pdf page here for excel exports.  We will pass down a flag to tell the components to not render for performance, but it will be in the component tree for excel export -->
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import { PageMixin } from '../../PageMixin'
import { router } from '../../../routes'

import MeritIncentiveOverallPage from './MeritIncentiveOverallPage.vue'
import MeritIncentiveConfigurationPage from './MeritIncentiveConfigurationPage.vue'
import MeritIncentiveOutstandingGrowthPage from './MeritIncentiveOutstandingGrowthPage.vue'
import MeritIncentiveShortageAreaPage from './MeritIncentiveShortageAreaPage.vue'
import MeritIncentiveMentoringPage from './MeritIncentiveMentoringPage.vue'
import MeritIncentiveCertifiedDistrictsPage from './MeritIncentiveCertifiedDistrictsPage.vue'
import MeritIncentiveUncertifiedDistrictsPage from './MeritIncentiveUncertifiedDistrictsPage.vue'

router.addRoutes([
  { path: '/HCPT/MeritIncentive', name: 'teacher-merit-home', component: MeritIncentiveOverallPage },
  { path: '/HCPT/MeritIncentive/Configuration', name: 'merit-incentive-configuration', component: MeritIncentiveConfigurationPage },
  { path: '/HCPT/MeritIncentive/OutstandingGrowth', name: 'merit-incentive-outstanding-growth', component: MeritIncentiveOutstandingGrowthPage },
  { path: '/HCPT/MeritIncentive/ShortageArea', name: 'merit-incentive-shortage-area', component: MeritIncentiveShortageAreaPage },
  { path: '/HCPT/MeritIncentive/Mentoring', name: 'merit-incentive-mentoring', component: MeritIncentiveMentoringPage },
  { path: '/HCPT/MeritIncentive/CertifiedDistricts', name: 'merit-incentive-certified-districts', component: MeritIncentiveCertifiedDistrictsPage },
  { path: '/HCPT/MeritIncentive/UncertifiedDistricts', name: 'merit-incentive-uncertified-districts', component: MeritIncentiveUncertifiedDistrictsPage },
]);


export default {
  mixins: [PageMixin],
  components: {
  },
  data() {
    return {
     
    }
  },
  computed: {
    currentLea() {
      return this.$route.params.lea
    }
  },
  created() {
  },
  methods: {
   
  }
}
</script>

<style scoped>

</style>
